import { emailValidate, nameValidate, passwordValidate } from "./Validate";
import { get, post, put } from "./api";
import getContactColumnsData from "./get-contact-columns-data";
const validate = {
	nameValidate,
	passwordValidate,
	emailValidate,
};

const api = {
	get,
	post,
	put,
};

const master = {
	validator: validate,
	api,
	getContactColumnsData,
};

export default master;
